import { AnyAction, PayloadAction } from '@reduxjs/toolkit'

export function isPending<T>(prefix = '') {
  return (action: AnyAction): action is PayloadAction<T> =>
    action.type?.endsWith('pending') && action.type?.startsWith(prefix)
}
